import apiRequest from "../../helpers/apiRequest";

export default async (tutor) => {
    return await apiRequest({
        method: 'get',
        url: `accounts/tutor/holidays?tutor_name=${tutor}`,
    })
}
